import React from 'react';

function EmptyData(){
    return (
        <div className={"troubles"} style={{color: "white",textAlign: "center", fontSize: "32px"}}>
            <img alt="Aktif Çağrı Yoktur" style={{width:128+"px",height:128+"px",marginTop:25+"px",marginBottom:20+"px"}} src={"./img/success.png"}/><br/><strong>Aktif çağrı yoktur</strong>
        </div>
    )
}


export default EmptyData;